import { Link } from "react-router";
import type { UserDetail } from "@/lib/users/user-detail";
import type { UserGroupItem } from "@/lib/users/user-group-item";
import type { UserExpenseItem } from "@/lib/users/user-expense-item";
import type { UserSessionItem } from "@/lib/users/user-session-item";
import { UserProfileView } from "@/components/users/user-profile-view";
import { UserActionsBar } from "@/components/users/user-actions-bar";
import { useLoaderData, type LoaderFunctionArgs } from "react-router";
import { load } from "../api/load";
import { seg } from "../api/respond";

type Data = {
  user: UserDetail;
  groups: UserGroupItem[];
  recentExpenses: UserExpenseItem[];
  sessions: UserSessionItem[];
};

export function loader({ params }: LoaderFunctionArgs) {
  return load<Data>(`/api/v1/admin/users/${seg(params.id!)}`);
}

export default function UserDetailPage() {
  const { user, groups, recentExpenses, sessions } = useLoaderData() as Data;
  const now = new Date();

  return (
    <div className="flex flex-col gap-6">
      <nav className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[13px] text-fc-text-secondary">
          <Link to="/admin" className="text-fc-text-dim hover:text-fc-text">
            Home
          </Link>
          <span className="text-fc-text-dim">/</span>
          <Link
            to="/admin/users"
            className="text-fc-text-dim hover:text-fc-text"
          >
            Users
          </Link>
          <span className="text-fc-text-dim">/</span>
          <span className="font-medium text-fc-text">{user.name}</span>
        </div>
        <Link
          to="/admin/users"
          className="inline-flex items-center gap-2 rounded-md border border-fc-border bg-fc-overlay px-3 py-1.5 text-[12.5px] text-fc-text hover:border-fc-brand"
        >
          ← Back to list
        </Link>
      </nav>

      <UserActionsBar
        userId={user.id}
        emailVerified={user.emailVerified}
        authProvider={user.authProvider}
        isSuspended={user.suspendedAt != null}
        isDeleted={user.deletedAt != null}
      />

      <UserProfileView
        user={user}
        now={now}
        groups={groups}
        recentExpenses={recentExpenses}
        sessions={sessions}
      />
    </div>
  );
}
